"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var className = 'Chapter';
var Chapter = /** @class */ (function () {
    function Chapter(title, seconds) {
        this.title = title;
        this.seconds = seconds;
    }
    Object.defineProperty(Chapter.prototype, "title", {
        get: function () {
            return this._title;
        },
        set: function (newTitle) {
            // if (typeof newTitle !== 'string') {
            //     throw new Error(`${className}.title must be a 'string'.`);
            // }
            this._title = newTitle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Chapter.prototype, "seconds", {
        get: function () {
            return this._seconds;
        },
        set: function (newSeconds) {
            if (!Number.isInteger(newSeconds)) {
                throw new Error("".concat(className, ".seconds must be an 'integer'."));
            }
            this._seconds = newSeconds;
        },
        enumerable: false,
        configurable: true
    });
    return Chapter;
}());
exports.default = Chapter;
